// store/index.js
import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        user: {
            userId: null,
            userName: null,
            mobile: null,
            companyId: null,
            funcKeys: [],
            channelAuths: {}
        },
        isLoading: false,  // 新增 isLoading 标识
    },
    mutations: {
        setUser(state, user) {
            state.user = user;
            state.isLoading = false;  // 数据加载完成
        },
        setLoading(state, status) {
            state.isLoading = status;  // 设置加载状态
        }
    },
    actions: {
        async fetchUser({ commit }) {
            commit('setLoading', true);  // 设置正在加载
            try {
                const token = sessionStorage.getItem("token");
                const response = await axios.get(`https://api.dzplus.dzng.com/gateway/authorization/manage/user/get/info/by/token?token=${token}`);
                // const response = await axios.get(`https://test.api.dzplus.dzng.cc/gateway/authorization/manage/user/get/info/by/token?token=${token}`);
                commit('setUser', response.data.data);
            } catch (error) {
                console.log("error", error);
                commit('setLoading', false);  // 出现错误时停止加载
            }
        }
    },
    getters: {
        isAuthenticated: state => !!state.user.userId,
        getUserName: state => state.user.userName,
        getMobile: state => state.user.mobile,
        getCompanyId: state => state.user.companyId,
        getUserPermissions: state => state.user.funcKeys,
        isLoading: state => state.isLoading  // 获取加载状态
    }
});
